(() => {
  let refreshTimeout = null;
  
  const style = document.createElement('style');
  style.textContent = `
    .cart-form.loading::before,
    .cart-form.loading::after {
      display: none !important;
    }
    .cart-form.loading {
      opacity: 1 !important;
      pointer-events: auto !important;
    }
  `;
  document.head.appendChild(style);
  
  $(document).on('cart:item-added cart:item-removed', function() {
    if(refreshTimeout) clearTimeout(refreshTimeout);
    
    refreshTimeout = setTimeout(() => {
      $(document).trigger('cart:refresh');
      refreshTimeout = null;
    }, 1500);
  });
})();

// Replo anchor class, Selling plan management, 
(() => {
  if (!window.location.pathname.includes('/products')) return;

  const initializeAbra = () => {
    if (window.Abra) {
      window.Abra.useSellingPlanPriceOnProductBlock = true;
      window.Abra.render();
    } else {
      setTimeout(initializeAbra, 100);
    }
  };

  if (window.location.pathname.includes('/products/beast-mode-bundle')) {
    const handleBeastModeBundle = () => {
      initializeAbra();

      const attachBeastModeListeners = () => {
        document.querySelectorAll('[role="radiogroup"] [role="button"]').forEach(button => {
          if (button.dataset.beastModeListenerAttached) return;
          
          button.addEventListener('click', () => {
            const text = button.textContent.toLowerCase();
            if (window.Abra) {
              window.Abra.useSellingPlanPriceOnProductBlock = text.includes('subscribe') && text.includes('save');
              window.Abra.render();
            }
          });
          
          button.dataset.beastModeListenerAttached = 'true';
        });
      };

      const observer = new MutationObserver(attachBeastModeListeners);
      observer.observe(document.body, { childList: true, subtree: true });
      attachBeastModeListeners();
    };

    handleBeastModeBundle();
    return;
  }

  const attachReploRadioListeners = () => {
    document.querySelectorAll('[role="radiogroup"]').forEach(radioGroup => {
      radioGroup.querySelectorAll('[role="button"]').forEach(button => {
        if (button.dataset.reploListenerAttached) return;
        
        button.addEventListener('click', () => {
          const text = button.textContent.toLowerCase();
          
          if (text.includes('subscribe') && text.includes('save')) {
            if (window.Abra) {
              window.Abra.useSellingPlanPriceOnProductBlock = true;
              window.Abra.render();
            }
          } else if (text.includes('one time') || text.includes('one-time')) {
            if (window.Abra) {
              window.Abra.useSellingPlanPriceOnProductBlock = false;
              window.Abra.render();
            }
          }
        });
        
        button.dataset.reploListenerAttached = 'true';
      });
    });
  };

  initializeAbra();
  attachReploRadioListeners();

  const applySkioClasses = () => {
    const picker = document.querySelector('skio-plan-picker');
    if (!picker?.shadowRoot) return false;
    
    const root = picker.shadowRoot;
    const containers = root.querySelectorAll('.group-container');
    
    if (!containers.length) return false;
    
    containers.forEach(container => {
      const title = container.querySelector('.group-title')?.textContent?.toLowerCase() || '';
      const priceEl = container.querySelector('.skio-price');
      
      if (!priceEl || priceEl.dataset.abraProcessed) return;
      
      if (title.includes('subscribe')) {
        priceEl.classList.add('subscribe');
      } else if (title.includes('one time')) {
        priceEl.classList.add('one-time');
      }
      
      priceEl.dataset.abraProcessed = 'true';
    });
    
    return true;
  };

  const applyReploClasses = () => {
    document.querySelectorAll('[data-replo-product-container]').forEach(container => {
      container.querySelectorAll('[role="button"]').forEach(button => {
        const text = button.textContent.toLowerCase();
        
        if (text.includes('subscribe') && text.includes('save')) {
          button.querySelectorAll('.alchemy-rte p').forEach(p => {
            const parent = p.closest('.alchemy-rte');
            const parentText = parent?.textContent.toLowerCase() || '';
            if (parent && parent.textContent.match(/\$\d+\.\d+/) && !parent.dataset.abraProcessed && !parentText.includes('shipping')) {
              parent.classList.add('subscribe-2');
              parent.dataset.abraProcessed = 'true';
            }
          });
        } else if (text.includes('one time')) {
          button.querySelectorAll('.alchemy-rte p').forEach(p => {
            const parent = p.closest('.alchemy-rte');
            const parentText = parent?.textContent.toLowerCase() || '';
            if (parent && parent.textContent.match(/\$\d+\.\d+/) && !parent.dataset.abraProcessed && !parentText.includes('shipping')) {
              parent.classList.add('one-time-2');
              parent.dataset.abraProcessed = 'true';
            }
          });
        }
      });
    });
  };

  const applyAtcClasses = () => {
    document.querySelectorAll('button[data-replo-add-product-variant-to-cart]').forEach(button => {
      const priceContainers = button.querySelectorAll('[data-rid]');
      
      priceContainers.forEach(container => {
        const priceElements = container.querySelectorAll('.alchemy-rte');
        const hasTwoPrices = priceElements.length === 2;
        const allHavePrices = Array.from(priceElements).every(el => el.textContent.match(/\$\d+\.\d+/));
        
        if (hasTwoPrices && allHavePrices && !container.dataset.abraProcessed) {
          container.classList.add('atc-wrapper');
          container.dataset.abraProcessed = 'true';
        }
      });
    });
  };

  const applySubscribePercentageClass = () => {
    document.querySelectorAll('.alchemy-rte').forEach(el => {
      if (el.dataset.abraPercentageProcessed) return;
      const text = el.textContent.trim();
      if (text.match(/^Subscribe\s*&\s*Save\s+\d+%$/i)) {
        el.classList.add('subscribe-percentage');
        el.dataset.abraPercentageProcessed = 'true';
      }
    });
  };

  const checkInitialSelection = () => {
    document.querySelectorAll('[role="radiogroup"]').forEach(radioGroup => {
      const buttons = radioGroup.querySelectorAll('[role="button"]');
      buttons.forEach(button => {
        const hiddenInput = button.nextElementSibling;
        if (hiddenInput?.type === 'radio' && hiddenInput?.checked) {
          const text = button.textContent.toLowerCase();
          
          if (text.includes('subscribe') && text.includes('save')) {
            if (window.Abra) {
              window.Abra.useSellingPlanPriceOnProductBlock = true;
              window.Abra.render();
            }
          } else if (text.includes('one time')) {
            if (window.Abra) {
              window.Abra.useSellingPlanPriceOnProductBlock = false;
              window.Abra.render();
            }
          }
        }
      });
    });
  };

  const attachRadioListeners = () => {
    document.querySelectorAll('[role="radiogroup"]').forEach(radioGroup => {
      radioGroup.querySelectorAll('[role="button"]').forEach(button => {
        if (button.dataset.abraListenerAttached) return;
        
        button.addEventListener('click', () => {
          const text = button.textContent.toLowerCase();
          
          if (text.includes('subscribe') && text.includes('save')) {
            if (window.Abra) {
              window.Abra.useSellingPlanPriceOnProductBlock = true;
              window.Abra.render();
            }
          } else if (text.includes('one time')) {
            if (window.Abra) {
              window.Abra.useSellingPlanPriceOnProductBlock = false;
              window.Abra.render();
            }
          }
        });
        
        button.dataset.abraListenerAttached = 'true';
      });
    });
  };

  let skioFound = false;
  let initialCheckDone = false;

  const observer = new MutationObserver(() => {
    if (!skioFound && applySkioClasses()) {
      skioFound = true;
    }
    applyReploClasses();
    applyAtcClasses();
    applySubscribePercentageClass();
    attachReploRadioListeners();
    attachRadioListeners();
    
    if (!initialCheckDone && document.querySelectorAll('[role="radiogroup"]').length > 0) {
      checkInitialSelection();
      initialCheckDone = true;
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  applySkioClasses();
  applyReploClasses();
  applyAtcClasses();
  applySubscribePercentageClass();
  attachReploRadioListeners();
  attachRadioListeners();
  checkInitialSelection();
})();

(() => {
  const productHandleMap = {
    '8168514093247': 'sexual-performance-booster'
  };

  document.querySelectorAll('form[data-product-id]').forEach(form => {
    const productId = form.getAttribute('data-product-id');
    const handle = productHandleMap[productId];
    if (handle) {
      const button = form.querySelector('button.button.primary.with-price.add-to-cart');
      if (button && !button.hasAttribute('data-product-handle')) {
        button.setAttribute('data-product-handle', handle);
      }
      form.querySelectorAll('button.button.primary.with-price.add-to-cart span.price').forEach(span => {
        if (!span.classList.contains('old') && !span.classList.contains('new')) {
          span.classList.add('new');
        }
      });
    }
  });

  if (window.Abra) {
    window.Abra.render();
  }

  const observer = new MutationObserver(() => {
    document.querySelectorAll('form[data-product-id]').forEach(form => {
      const productId = form.getAttribute('data-product-id');
      const handle = productHandleMap[productId];
      if (handle) {
        const button = form.querySelector('button.button.primary.with-price.add-to-cart');
        if (button && !button.hasAttribute('data-product-handle')) {
          button.setAttribute('data-product-handle', handle);
        }
        form.querySelectorAll('button.button.primary.with-price.add-to-cart span.price').forEach(span => {
          if (!span.classList.contains('old') && !span.classList.contains('new')) {
            span.classList.add('new');
          }
        });
        if (window.Abra) {
          window.Abra.render();
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();